import React from 'react'

export default function Collaboration() {
    return (
        <>
            <section class="page-title-center-alignment cover-background top-space-padding" style={{ backgroundImage: `url(images/about-title-bg.jpg)` }}>

                <div class="container">

                    <div class="row">

                        <div class="col-12 text-center position-relative page-title-extra-large">

                            <h1 class="alt-font d-inline-block fw-700 ls-minus-05px text-base-color mb-10px mt-3 md-mt-50px">Collaboration</h1>

                        </div>

                        <div class="col-12 breadcrumb breadcrumb-style-01 d-flex justify-content-center">

                            <ul>

                                <li><a href="index.php">Home</a></li>

                                <li>Collaboration</li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- end page title --> */}

            {/* <!-- start section --> */}

            <section class=" position-relative overflow-hidden">

                <div class="container">

                    <div class="row mb-4 align-items-center text-center text-sm-start">

                        <div class="col-lg-1 col-md-3 col-sm-4 xs-mb-20px">



                        </div>

                        <div class="col-lg-5 col-md-7 col-sm-8" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <span class="text-uppercase fs-13 ls-2px fw-600 mb-5px d-block">Your Handloom Import Solution.</span>

                            <h3 class="text-dark-gray alt-font fw-700 mb-0">Cultivating Partnership</h3>

                        </div>

                        <div class="col-lg-6 md-mt-30px last-paragraph-no-margin" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <p>Cultivating Partnership, Delivering Excellence: Your Handloom Import Solution

                                At Apollo Overseas, we aren't just suppliers, we're trusted partners. We believe in fostering collaborative relationships that go beyond mere transactions, focusing on your unique needs and aspirations.
                            </p>

                        </div>

                    </div>

                </div>

                <div class="container-fluid">

                    <div class="row align-items-center">

                        <div class="col-md-3 text-center p-4 md-p-15px" data-bottom-top="transform: translateY(-80px)" data-top-bottom="transform: translateY(80px)">

                            <img class="w-100" src="images/pt-img-02.jpg" alt="" />

                        </div>

                        <div class="col-md-6 text-center" data-bottom-top="transform: translateY(80px)" data-top-bottom="transform: translateY(-80px)">

                            <img class="w-100" src="images/pt-img-01.jpg" alt="" />

                        </div>

                        <div class="col-md-3 text-center p-4 md-p-15px" data-bottom-top="transform: translateY(-80px)" data-top-bottom="transform: translateY(80px)">

                            <img class="w-100" src="images/pt-img-03.jpg" alt="" />

                        </div>

                    </div>

                </div>



            </section>

            <section data-parallax-background-ratio="0.5" style={{ backgroundImage: `url(images/home-parallax.jpg)` }}>

                <div class="opacity-light bg-base-color"></div>

                <div class="container">

                    <div class="row align-items-center justify-content-center" data-anime='{ "el": "childs", "translateX": [50, 0],"opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'>

                        <div class="col-lg-6 col-md-8">

                            <div class="bg-white p-70px lg-p-35px position-relative border-radius-6px">

                                <div class="swiper slider-one-slide text-slider-style-01 magic-cursor" data-slider-options='{ "slidesPerView": 1, "loop": true, "pagination": { "el": ".slider-one-slide-pagination", "clickable": true }, "autoplay": { "delay": 4000, "disableOnInteraction": false }, "navigation": { "nextEl": ".slider-one-slide-next-1", "prevEl": ".slider-one-slide-prev-1" }, "keyboard": { "enabled": true, "onlyInViewport": true }, "effect": "slide" }'>

                                    <div class="swiper-wrapper mb-10px">

                                        {/* <!-- start text slider item --> */}

                                        <div class="swiper-slide last-paragraph-no-margin">

                                            <div class="alt-font text-center text-uppercase fs-13 fw-600 mb-5px ls-2px">Who do we partner with?</div>

                                            <h3 class="alt-font text-dark-gray fw-700 ls-minus-1px text-center">Retailers</h3>

                                            <p class="w-90 lg-w-100 text-center">

                                                Elevate your product offerings with unique, ethically sourced handlooms that resonate with today's conscious consumers..</p>

                                        </div>

                                        {/* <!-- end text slider item --> */}

                                        {/* <!-- start text slider item --> */}

                                        <div class="swiper-slide">

                                            <div class="alt-font text-uppercase fs-13 fw-600 mb-5px ls-2px text-center">Who do we partner with?</div>

                                            <h3 class="alt-font text-dark-gray fw-700 ls-minus-1px text-center">Small Businesses</h3>

                                            <p class="w-90 lg-w-100 text-center">

                                                Expand your product line without the hassle of complex import procedures. We'll be your one-stop solution for high-quality handlooms.</p>

                                        </div>

                                        {/* <!-- end text slider item --> */}



                                    </div>



                                </div>

                            </div>

                        </div>

                    </div>





                </div>



            </section>

            {/* <!-- end section --> */}

            {/* <!-- start section --> */}

            <section class="">

                <div class="container">

                    <div class="row justify-content-center mb-40px sm-mb-30px">

                        <div class="col-lg-5 text-center" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>



                            <h4 class="alt-font text-dark-gray fw-700 mb-20px">Why Choose Us</h4>

                            <span class="text-uppercase fs-13 ls-2px fw-600">Expertise, Experience & Customer Preferences</span>

                        </div>

                    </div>

                    <div class="row row-cols-auto row-cols-xl-4 row-cols-sm-2 lg-ps-10 lg-pe-10 md-ps-7 md-pe-7 sm-ps-0 sm-pe-0 position-relative mb-6 md-mb-8 lg-mt-20px" data-anime='{ "el": "childs", "translateX": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-start xs-mb-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">One</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Tailored Import Solutions</span>

                                    <p>Share your specific product requirements, and our dedicated team will curate a customized import plan just for you. No more limitations, only curated collections that reflect your brand and customer preferences.</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}



                        <div class="col align-self-end mt-30px lg-mt-0">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">Two</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Diverse Handloom Expertise </span>

                                    <p> From luxurious bedding sets to plush bath essentials, explore our wide range of handcrafted products, or delve into custom fabric sourcing for truly unique creations</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-start lg-mt-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">Three</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Seamless Import Experience</span>

                                    <p> Leave the logistics to us! We handle the entire import process, from sourcing and quality control to customs clearance and delivery, ensuring a smooth and efficient experience.</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-end lg-mt-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">Four</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Unwavering Support</span>

                                    <p> Our dedicated team is here to guide you every step of the way. We offer expert advice, market insights, and ongoing support to ensure your success.
                                    </p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                    </div>



                </div>

            </section>
        </>
    )
}
